import AxiosConfig from '../../../config/AxiosConfig';

const useRetractOrderSAV = () => {
  const retractOrderSAV = async (orderRef, retractionData) => {
    try {
      const response = await AxiosConfig.create(
        'post',
        `/orders/${orderRef}/retractOrderSAV`
      )
        .call(retractionData)
        .getResponseData();

      return response;
    } catch (err) {
      console.error('Failed to retract order SAV:', err);
      throw new Error(`SAV Order retraction failed: ${err.message}`);
    }
  };

  return {
    retractOrderSAV,
  };
};

export default useRetractOrderSAV;
